export const default_settings = {
  autoplay_next_track: false,
  autoplay_next_tag: false,
  continue_last_tag: false,
  loop: false,
  tagging_mode: process.env.VUE_APP_TAGGING_MODE,
  default_tab: process.env.VUE_APP_DEFAULT_TAB,
  default_track_name: process.env.VUE_APP_DEFAULT_TRACK_NAME,
  default_track_color: process.env.VUE_APP_DEFAULT_TRACK_COLOR,
  default_track_note: '',
  default_tag_duration: parseInt(process.env.VUE_APP_DEFAULT_TAG_DURATION),
  default_tag_lag_time: parseInt(process.env.VUE_APP_DEFAULT_TAG_LAG_TIME),
};

export const default_track = {
  id: 'trackless',
  name: default_settings.default_track_name,
  color: default_settings.default_track_color,
  order: 0,
};

export const default_layout = {
  show_tags: true,
  show_tracks: true,
  show_controls: true,
  show_empty_tracks: true,
  video_size: '50',
};

export const default_keymap: any = {
  q: 0,
  81: 0,
  w: 1,
  87: 1,
  e: 2,
  69: 2,
  r: 3,
  82: 3,
  t: 4,
  84: 4,
  y: 5,
  89: 5,
  u: 6,
  85: 6,
  i: 7,
  73: 7,
  o: 8,
  79: 8,
  p: 9,
  80: 9,
  Backspace: 'undo',
  8: 'undo',
};
